module.exports = __webpack_public_path__ + "static/media/road-glide-special-billiard-teal.4dd49dd4.png";